import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";

import {
  Grid,
  createStyles,
  makeStyles,
  TextField,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Box,
} from "@material-ui/core";

import { POST_UPDATE_PROJECT_TYPE } from "../../../services/options";
import { useSnackbar } from "notistack";
import api from "../../../services/Api";
import { ButtonSuccess } from "../../../Components/ButtonSuccess";
import DefaultModal, {
  DefaultModalActions,
  DefaultModalContent,
} from "../../../Components/DefaultModal";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "grid",
      [theme.breakpoints.up("xs")]: {
        width: 380,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("sm")]: {
        width: 450,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("md")]: {
        width: 500,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("lg")]: {
        width: 500,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("xl")]: {
        width: 520,
        padding: theme.spacing(0, 1, 0, 1),
      },
    },
  })
);

const validationSchema = Yup.object().shape({
  tipo: Yup.string().required("Obrigatório"),
  medicao: Yup.number().required("Obrigatório"),
});

export default function Edit({ data, setData, open, setOpen, updateData }) {
  const { enqueueSnackbar } = useSnackbar();

  const submit = async (values, { setSubmitting }) => {
    const buffer = {
      id: data.id,
      tipo: values.tipo,
      medicao: values.medicao === 1 ? true : false,
    };

    await api(POST_UPDATE_PROJECT_TYPE(buffer)).then(r=>{
      const {data} = r;
      if(data.status === "success"){
        updateData();
        setSubmitting(false);
        close();
        enqueueSnackbar("Tipo de projeto atualizado !!!", { variant: "success" });
        setData({
          id: data.id,
          name: values.tipo,
          medicao: values.medicao === 1 ? "Sim" : "Não",
        });
      }else{
        setSubmitting(false);
        enqueueSnackbar(`Erro ao atualizar tipo de projeto`, { variant: "Error" });
      }
    }).catch(e=>{
      setSubmitting(false);
      enqueueSnackbar(`Erro ${e.message}`, { variant: "Error" });
    })
  };

  const close = () => {
    setOpen(false);
  };

  return (
    <DefaultModal
      open={open}
      loading={data === null}
      handleClose={close}
      title="Editar tipo de projeto"
    >
      <Formik
        initialValues={data}
        validationSchema={validationSchema}
        onSubmit={submit}
      >
        {(props) => <Forms {...props} />}
      </Formik>
    </DefaultModal>
  );
}

const Forms = (props) => {
  const classes = useStyles();
  const {
    values,
    touched,
    errors,
    isSubmitting,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = props;

  return (
    <form onSubmit={handleSubmit} noValidate>
      <DefaultModalContent dividers>
        <Grid container className={classes.root} spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              maxRows={5}
              variant="outlined"
              size="small"
              autoFocus
              inputProps={{ autoComplete: "off" }}
              id="tipo"
              label="Tipo"
              name="tipo"
              onChange={handleChange}
              value={values.tipo}
              error={touched.tipo && Boolean(errors.tipo)}
              helperText={touched.tipo && errors.tipo}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Medição</FormLabel>
              <RadioGroup
                aria-label="medicao"
                name="medicao"
                id="medicao"
                value={values.medicao}
                onChange={(e, value) => {
                  setFieldValue("medicao", Number(value));
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <FormControlLabel value={1} control={<Radio />} label="Sim" />
                  <FormControlLabel value={0} control={<Radio />} label="Não" />
                </div>
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </DefaultModalContent>
      <DefaultModalActions style={{ margin: "0.5rem" }}>
        <ButtonSuccess
          style={{ width: 110 }}
          variant="contained"
          color="primary"
          type="submit"
          success={false}
          loading={isSubmitting}
        >
          {" "}
          Salvar
        </ButtonSuccess>
      </DefaultModalActions>
    </form>
  );
};
